// extracted by mini-css-extract-plugin
export default {"panel":"panel--lglEU","mobile":"mobile--PxsGm","divider":"divider--matNM"};